import React from 'react';

import { postMessageToChannel } from '../../../shared/services/bridge';
import { useScrollListener } from '../hooks';

import './TermsOfService.css';

const TermsOfService: React.FC = () => {
  // スクロール最下部到達時にFlutterへ通知
  useScrollListener({
    onReachBottom: () => {
      postMessageToChannel('ScrollListener', 'scrolledToBottom');
    },
  });

  return (
    <main className="terms-container">
      <h1>home karte利用規約</h1>
      <p>home karte利用規約（以下「本規約」といいます。）は、FLUCT株式会社（以下「当社」といいます。）が提供するエンドユーザー向けアプリ「home karte（ホームカルテ）」（以下「本サービス」といいます。）の利用条件を定めるものです。本サービスの利用者（第2条で定義します。）は、本規約及び当社プライバシーポリシー（https://co.fluct.inc/privacy-policy.html）の内容を確認し、同意した上で本サービスを利用するものとします。</p>
      <h2>第1条（適用）</h2>
      <ol>
        <li>本規約は、本サービスの利用に関する当社と利用者との一切の関係に適用されます。</li>
        <li>当社が本サービス上で表示する注意事項、案内その他の事項は、本サービスの具体的な利用方法又は機能に関する説明として適用されます。ただし、これらによって本規約に定める利用者の権利又は義務を変更するものではありません。</li>
        <li>本サービスの具体的な機能、画面、操作方法、情報の表示方法、反映時期その他の技術的事項は、当社所定の仕様によります。ただし、当該仕様によって本規約に定める利用者の権利又は義務を変更するものではありません。</li>
      </ol>
      <h2>第2条（定義）</h2>
      <p>本規約で用いる用語の定義は、以下のとおりとします。</p>
      <ol className="paren-list">
        <li>「個人情報」：個人情報の保護に関する法律（平成十五年法律第五十七号。以下「個人情報保護法」といいます。）に定義する個人情報</li>
        <li>「個人データ」：個人情報保護法に定義する個人データ</li>
        <li>「第三者サービスプロバイダ」：当社が本サービスを提供する上で必要となるサービス（クラウド、アプリストア、ソフトウェア及び決済サービスを含みます。）を提供する第三者</li>
        <li>「対象物件」：利用者が本サービスで管理し、又は管理対象として登録する住宅、住宅設備その他の対象</li>
        <li>「提携事業者」：当社が提供する業務支援システム「HomeDoctor（ホームドクター）」（以下「HomeDoctor」といいます。）その他当社が指定するシステムを利用し、住宅設備等の点検、修繕その他の役務（以下「点検等役務」といいます。）を提供し、又は当該役務に関する受付、契約、請求その他の業務を行う事業者</li>
        <li>「顧客基本情報」：利用者の氏名、カタカナ氏名（姓及び名の双方を含むもの）、携帯電話番号、メールアドレス、基本住所その他当社がHomeDoctorとの連携対象として定める基本的な顧客情報</li>
        <li>「利用者データ」：利用者が本サービスに入力、送信若しくはアップロードし、又は本サービスの利用に伴い生成若しくは蓄積される情報、並びに提携事業者がHomeDoctorに入力し本サービスに表示又は連携される点検等役務、見積、注文、作業、支払、報告その他に関する情報</li>
        <li>「アライアンス事業者」：当社が、本サービス又はHomeDoctorに蓄積されたデータを活用し、住宅、設備、修繕等に関するサービス連携、データ連携その他の業務提携を行う法人その他の事業者であって、当社との間でデータの利用目的、対象項目、取扱条件その他必要な事項を定める書面による契約を締結した者</li>
        <li>「反社会的勢力」：暴力団、暴力団関係企業、総会屋、社会運動標榜ゴロ、特殊知能暴力集団その他これらに準ずる者、並びに暴力、威力又は詐欺的手法を駆使して経済的利益を追求する者</li>
        <li>「利用者」：本サービスの利用登録を行い、本サービスを利用する個人</li>
      </ol>
      <h2>第3条（本サービスの内容）</h2>
      <ol>
        <li>
          本サービスは、主として以下の機能を提供します。
          <ol className="paren-list">
            <li>住宅、設備、点検及び修繕に関する情報並びに履歴の閲覧・保存</li>
            <li>提携事業者との連携、受付状況及び訪問予定等の確認</li>
            <li>見積内容の確認、注文その他の電子的な意思表示</li>
            <li>注文サイン、納品サインその他当社所定の電子的な手続</li>
            <li>クレジットカード、後払いその他当社が指定する方法による決済手続</li>
            <li>報告書、請求書、領収書その他の書類又は情報の確認</li>
            <li>通知、リマインダー、問い合わせ及び履歴照会</li>
          </ol>
        </li>
        <li>前項の決済機能その他の一部機能は、第三者サービスプロバイダとの契約により提供される場合があります。利用者は、当該機能の利用に当たり、第三者サービスプロバイダが定める規約、条件その他の定めへの同意又は遵守が必要となることがあることをあらかじめ承諾するものとします。</li>
        <li>当社は、合理的な必要がある場合、本サービスの一部若しくは全部の提供を停止し、又はその内容を変更することがあります。当社の責めに帰すべき事由がある場合を除き、当社は、当該停止又は変更により利用者に生じた損害について責任を負いません。</li>
        <li>当社は、本サービスの停止又は変更について事前の通知が合理的に可能な場合、本サービス上の表示その他適切な方法により、あらかじめ利用者に通知するよう努めます。ただし、緊急の保守、セキュリティ上の必要、第三者サービスの停止その他事前の通知が困難な場合は、この限りではありません。</li>
      </ol>
      <h2>第4条（利用登録及び利用契約の成立）</h2>
      <ol>
        <li>本サービスの全部又は一部の機能を利用するためには、当社所定の方法による利用登録が必要です。利用登録に当たり、当社は、携帯電話番号に対するSMS認証その他当社所定の方法による本人確認又は認証を行います。</li>
        <li>利用者が必要事項を入力し、本規約及び当社プライバシーポリシーその他当社が指定する事項に同意した上で利用登録を行い、当社のシステム上で当該利用登録が正常に完了した時点で、当社と利用者との間に本規約を内容とする利用契約が成立します。</li>
        <li>利用者は、利用登録又は本サービスの利用に必要な情報を真実かつ正確な内容で登録するものとします。</li>
        <li>本サービスの利用登録は、18歳以上の者に限ります。利用者は、利用登録時点において18歳以上であることを表明し、保証するものとします。</li>
        <li>利用登録時に入力された携帯電話番号及びカタカナ氏名の組み合わせが、既存の利用者アカウントに登録されている組み合わせと一致する場合、当社は、新たな利用登録を受け付けません。</li>
      </ol>
      <h2>第5条（アカウント、認証情報及び権利義務の管理）</h2>
      <ol>
        <li>利用者は、携帯電話番号、認証コード、パスワードその他本サービスの利用又は本人認証に用いる情報（以下「認証情報」といいます。）を自己の責任で適切に管理し、第三者に使用させてはなりません。</li>
        <li>利用者は、認証情報の不正利用又は第三者による利用のおそれがあることを知った場合、速やかに当社所定の方法により必要な措置を講じるものとします。</li>
        <li>認証情報の管理不十分又は第三者による不正利用によって利用者に損害が生じた場合、当社の責めに帰すべき事由がある場合を除き、当社は責任を負いません。</li>
        <li>利用者は、当社の事前の承諾なく、自己のアカウント若しくは利用契約上の地位又は本規約に基づく権利若しくは義務を、第三者に譲渡し、貸与し、名義変更し、又はその他の方法により処分することはできません。</li>
        <li>対象物件の売買、相続その他の事情が生じた場合であっても、利用者のアカウント、利用者データ又は提携事業者との連携が当然に第三者へ移転又は承継されるものではありません。その取扱いは、当社が別途定める方法によります。</li>
      </ol>
      <h2>第6条（利用者データの取扱い）</h2>
      <ol>
        <li>利用者データに関する権利は、利用者、提携事業者又はその他の正当な権利者に帰属します。</li>
        <li>当社は、利用者データを、本サービスの提供、保守、サポート、セキュリティの確保、不正利用の防止、障害対応、法令遵守その他本サービスの運営に合理的に必要な範囲で取り扱います。</li>
        <li>当社は、前項の目的に必要な範囲で、第三者サービスプロバイダその他の委託先に利用者データの取扱いを委託することができます。この場合、当社は、適用法令に従い、当該委託先を適切に選定し、必要な監督を行います。</li>
        <li>当社は、利用者データについて、不正アクセス、漏えい、滅失又は毀損の防止その他安全管理のため、合理的かつ必要な措置を講じます。</li>
        <li>当社は、特定の利用者又は提携事業者を識別できない形式に加工又は集計した統計情報を作成し、本サービスの改善、品質向上、利用状況の分析、新たなサービスの企画その他当社の事業のために利用し、又は第三者に提供することができます。</li>
        <li>個人情報及び個人データの取扱いについては、本規約のほか、個人情報保護法その他適用法令及び当社プライバシーポリシーに従います。</li>
      </ol>
      <h2>第7条（HomeDoctorとの連携）</h2>
      <ol>
        <li>本サービスは、HomeDoctor上の提携事業者の顧客情報と連携することができます。本サービスの利用登録は、HomeDoctorに利用者の顧客情報があらかじめ登録されていることを要しません。</li>
        <li>利用者の本サービス上のアカウントと提携事業者がHomeDoctorで管理する顧客情報との連携は、当社所定の方法により利用者本人が承認した場合に限り成立します。連携の承認は提携事業者ごとに個別に行われ、一の提携事業者との連携承認をもって、他の提携事業者との連携が自動的に成立するものではありません。</li>
        <li>前項の連携が成立した後は、顧客基本情報について本サービスに登録された情報を基準とします。利用者が本サービス上で顧客基本情報を変更した場合、当該変更内容は、利用者と連携しているすべての提携事業者のHomeDoctor上の顧客情報に反映されます。</li>
        <li>HomeDoctor上から連携済みの顧客基本情報の変更申請が行われた場合、当社は、本サービス上で利用者本人に承認を求めます。利用者が承認するまでは変更前の情報を維持し、承認後に変更内容を本サービス及び利用者と連携しているすべての提携事業者のHomeDoctor上の顧客情報に反映します。</li>
        <li>携帯電話番号その他当社が指定する顧客基本情報は、HomeDoctorから変更することができず、本サービス上でSMS認証その他当社所定の本人認証手続を経て変更するものとします。</li>
        <li>顧客基本情報を変更する場合、変更後の携帯電話番号及びカタカナ氏名の組み合わせが他の利用者アカウントに登録されている組み合わせと一致するときは、当該変更を行うことができません。HomeDoctorからの変更申請については、利用者が承認し、変更が確定する時点で当該一致の有無を判定します。</li>
        <li>本サービスと複数の提携事業者が連携している場合であっても、問い合わせ、依頼、訪問、修繕履歴、アサイン、見積、注文、納品、支払、報告書、写真その他提携事業者又は案件に固有の情報が、当該連携のみを理由として他の提携事業者に共有されることはありません。</li>
        <li>前項にかかわらず、点検等役務の受付、手配、施工その他当該案件の遂行のため、提携事業者間で、利用者情報、対象物件・設備情報、依頼内容、見積・注文・作業・請求・決済に関する情報その他当該案件に必要な情報が共有される場合があります。当該共有について個人情報保護法その他適用法令上、本人への通知、同意取得その他の措置が必要となる場合、当該情報を共有する提携事業者は、必要な措置を講じるものとします。</li>
        <li>利用者が提携事業者との連携を承認しない場合又は連携前である場合であっても、提携事業者は、HomeDoctorその他当社所定の方法により、利用者に対する点検等役務に関する手続を行うことがあります。この場合、本サービス上では、当該連携が成立するまで当該案件に関する一部の機能を利用できないことがあります。</li>
      </ol>
      <h2>第8条（提携事業者との取引及び電子的な手続）</h2>
      <ol>
        <li>点検等役務に関する契約、見積、注文、請求、決済その他の取引の主体は、当該案件の取引関係及び本サービス上の表示、注文書、請求書その他の画面又は帳票に従います。当社が当該画面又は帳票上で契約当事者として表示される場合を除き、当社は点検等役務に関する契約の当事者ではありません。</li>
        <li>利用者が本サービス上で見積内容若しくは注文内容を確認し、注文サイン、納品サインその他当社所定の操作を行った場合、当該操作は、画面又は帳票に表示された内容について利用者が行った電子的な意思表示として取り扱われます。</li>
        <li>提携事業者が提供する点検等役務の内容、品質、価格、瑕疵、遅延、再施工、キャンセル、返金その他点検等役務そのものに関する事項については、当該取引の当事者である事業者が責任を負います。当社は、当社の責めに帰すべき事由がある場合を除き、これらについて責任を負いません。</li>
        <li>利用者は、点検等役務に関する問い合わせ、苦情、キャンセル、返金、再施工その他の事項について、当該案件の契約又は取引の主体として表示された事業者に連絡するものとします。</li>
      </ol>
      <h2>第9条（アライアンス事業者への個人データ等の提供）</h2>
      <ol>
        <li>当社は、住宅、設備、修繕等に関するサービス連携又はデータ連携を行うアライアンス事業者に対して利用者データを提供し、又はアライアンス事業者のシステムと連携する場合があります。</li>
        <li>前項の提供又は連携に利用者の個人データが含まれる場合、当社は、当該個人データを提供する前に、注文サイン時その他当社所定の方法により、利用者に対し、提供先の範囲又は属性、利用目的、提供する情報の範囲その他法令上必要な事項を表示し、同意チェックその他本人の意思を確認できる方法により同意を取得した場合に限り、当該個人データを提供します。</li>
        <li>前項に基づき提供する情報には、氏名、連絡先、対象物件及び設備に関する情報、依頼、見積及び注文内容、作業内容、修繕履歴、支払状況その他本件対応に必要な情報が含まれることがあります。クレジットカード番号、有効期限及びセキュリティコードは、提供対象に含まれません。</li>
        <li>当社は、前項の同意に関する日時、同意対象、表示内容のバージョンその他当社が必要と定める記録を、法令遵守、同意の確認、紛争対応その他合理的に必要な範囲で保存することがあります。</li>
        <li>当社は、アライアンス事業者へのデータ提供又は連携に先立ち、当該アライアンス事業者との間で、データの利用目的、対象項目、利用範囲、安全管理措置、目的外利用及び再提供の制限、契約終了時の取扱いその他必要な事項を定める書面による契約を締結します。</li>
        <li>アライアンス事業者による利用者データの利用は、前項の契約及び当社が利用者に示した利用目的の範囲に限られます。</li>
      </ol>
      <h2>第10条（利用料）</h2>
      <ol>
        <li>本サービスの基本的な利用料は無料とします。ただし、本サービスの利用に必要な通信料、端末費用その他利用者側で発生する費用は、利用者の負担とします。</li>
        <li>当社は、本サービスの一部に有料サービスを追加することがあります。この場合、利用者が当社所定の方法により当該有料サービスに申し込んだ場合に限り、その料金及び条件が適用されます。</li>
      </ol>
      <h2>第11条（決済）</h2>
      <ol>
        <li>利用者は、点検等役務その他の取引に関する支払手段として、当社又は当該取引の主体となる事業者が指定するクレジットカード、後払いその他の決済手段を利用することができます。</li>
        <li>決済に関する手数料、支払期日、利用上限、与信審査、売上取消、返金、遅延損害金その他の条件は、本サービス上の表示、当該取引の主体となる事業者が提示する条件及び第三者サービスプロバイダが定める規約その他の条件に従います。</li>
        <li>クレジットカード決済に際して利用者が入力するクレジットカード番号、有効期限及びセキュリティコードその他当社が指定するカード情報は、決済事業者のシステムへ直接送信され、当社のサーバーでは取得、保存又は保持しません。当社は、決済事業者から発行されるトークンその他カード番号等そのものを含まない決済処理に必要な情報を利用します。</li>
        <li>当社は、決済そのものの提供主体ではなく、当該取引に係る売上金について、利用者又は取引の主体となる事業者のために収納代行、預託、立替又は保管を行うものではありません。</li>
      </ol>
      <h2>第12条（禁止事項）</h2>
      <p>利用者は、以下の各号に該当する行為を行ってはなりません。</p>
      <ol className="paren-list">
        <li>法令又は公序良俗に違反する行為</li>
        <li>第三者の権利又は利益を侵害する行為</li>
        <li>虚偽情報の登録、なりすましその他不正な方法による利用</li>
        <li>不正アクセス、脆弱性探索、リバースエンジニアリングその他これらに類する行為</li>
        <li>当社、提携事業者、第三者サービスプロバイダその他第三者のシステム又は業務を妨害する行為</li>
        <li>本サービスを第三者に不正に利用させ、又は第三者の認証情報を使用する行為</li>
        <li>反社会的勢力の活動を助長し、又はこれに利益を供与する行為</li>
        <li>その他本サービスの運営若しくは提供又は第三者に重大な支障若しくは損害を及ぼす行為</li>
      </ol>
      <h2>第13条（知的財産権）</h2>
      <ol>
        <li>本サービスに関する一切の知的財産権（権利化する権利を含みます。）は、当社又は正当な権利者に帰属します。</li>
        <li>利用者は、本規約に従い、本サービスを利用するために必要な範囲で、前項に定める知的財産権を非独占的に利用することができます。</li>
      </ol>
      <h2>第14条（退会及び連携終了）</h2>
      <ol>
        <li>利用者は、当社所定の方法により、いつでも本サービスを退会することができます。退会手続が完了した時点で、当社と利用者との間の利用契約は終了します。</li>
        <li>利用者が退会した場合、又は利用者と提携事業者とのHomeDoctor連携が終了した場合、当該連携に基づく顧客基本情報の同期は停止します。</li>
        <li>前項の場合であっても、連携終了時点でHomeDoctor上に反映されている顧客基本情報並びに提携事業者が保有する問い合わせ、依頼、修繕履歴、見積、注文、納品、支払、報告その他の取引又は対応に関する情報は、当該提携事業者側に保持されることがあります。連携終了後、各提携事業者は、自己が管理する顧客情報を個別に管理又は編集することができます。</li>
        <li>利用者が本サービスを退会した後に再度利用登録した場合であっても、従前の提携事業者との連携が自動的に復活するものではありません。再度連携する場合は、当社所定の方法により改めて本人承認を行う必要があります。</li>
        <li>利用者が、携帯電話番号を変更できない場合その他の理由により、従前のアカウントとは別のアカウントとして新たに利用登録した場合、従前のアカウントに係る利用者データ、提携事業者との連携、承認履歴その他の情報は、新たなアカウントに当然には引き継がれません。データの移行又は引継ぎを行う場合の条件及び手続は、当社が別途定める方法によります。</li>
        <li>退会後の利用者データの保持、削除、閲覧可否、バックアップその他の取扱いについては、本規約及び当社プライバシーポリシーに従います。</li>
      </ol>
      <h2>第15条（利用停止及び解除）</h2>
      <ol>
        <li>当社は、利用者が本規約に違反した場合、相当期間を定めてその是正を求め、当該期間内に是正されないときは、本サービスの全部若しくは一部の利用を停止し、又は利用契約を解除することができます。</li>
        <li>
          当社は、利用者について次の各号のいずれかに該当する事由が生じた場合、事前の催告又は通知をすることなく、本サービスの全部若しくは一部の利用を停止し、又は利用契約を解除することができます。
          <ol className="paren-list">
            <li>利用登録情報その他当社に提供した重要な情報に虚偽又は重大な不備があることが判明した場合</li>
            <li>第12条に定める禁止事項に重大に違反した場合</li>
            <li>不正利用、セキュリティ上の重大な問題その他本サービスの運営又は第三者に重大な影響を及ぼすおそれがある場合</li>
            <li>過去に本規約その他当社との契約について重大な違反があり、当該事実が利用契約成立後に判明した場合</li>
            <li>その他前各号に準ずる重大な事由がある場合</li>
          </ol>
        </li>
        <li>前二項に基づく利用停止又は解除により利用者に損害が生じた場合であっても、当社の責めに帰すべき事由がある場合を除き、当社は責任を負いません。</li>
      </ol>
      <h2>第16条（非保証）</h2>
      <p>当社は、本サービスに関し、以下の事項を明示又は黙示を問わず保証しません。</p>
      <ol className="paren-list">
        <li>本サービスに表示される情報の完全性、正確性、最新性又は特定目的への適合性</li>
        <li>本サービスが中断なく提供されること又はエラー若しくは障害が発生しないこと</li>
        <li>提携事業者又は第三者サービスプロバイダが提供するサービスの内容、品質、継続性その他の事項</li>
      </ol>
      <h2>第17条（免責及び損害賠償）</h2>
      <ol>
        <li>当社は、当社の責めに帰すべき事由による場合を除き、本サービスに関して利用者に生じた損害について責任を負いません。</li>
        <li>当社は、提携事業者又は第三者サービスプロバイダが提供する役務若しくはサービスに起因する損害について、当社の責めに帰すべき事由がある場合を除き、責任を負いません。</li>
        <li>当社が本サービスに関して利用者に対して損害賠償責任を負う場合、当社の故意又は重過失による場合を除き、賠償の範囲は、当社の責めに帰すべき事由と相当因果関係のある通常損害に限ります。</li>
        <li>前各項は、消費者契約法その他の法令により制限される範囲を超えて当社の責任を免除するものではありません。</li>
      </ol>
      <h2>第18条（存続規定及び契約終了後の措置）</h2>
      <ol>
        <li>利用契約が退会、解除その他の理由により終了した場合であっても、第6条、第7条第7項及び第8項、第8条、第9条、第11条、第13条、第14条第2項から第6項まで、第15条第3項、第16条、第17条、本条、第19条第2項及び第21条の規定は、その性質に反しない範囲で引き続き効力を有します。</li>
        <li>利用契約終了後であっても、当社は、法令上の義務の履行、取引又は同意に関する記録の保存、紛争対応その他本サービスの運営上合理的に必要な範囲で利用者データを保持することがあります。利用者データの取扱いについては、第6条及び当社プライバシーポリシーに従います。</li>
      </ol>
      <h2>第19条（反社会的勢力の排除）</h2>
      <ol>
        <li>利用者は、自身が反社会的勢力ではなく、かつ反社会的勢力と社会的に非難されるべき関係を有していないことを表明し、保証します。</li>
        <li>利用契約成立後に利用者が反社会的勢力であることその他前項に反する事実が判明した場合、当社は、何らの事前通知又は催告を要することなく、本サービスの利用を停止し、又は利用契約を解除することができます。この場合、当社の責めに帰すべき事由がある場合を除き、当社は当該措置によって利用者に生じた損害について責任を負いません。</li>
      </ol>
      <h2>第20条（規約変更）</h2>
      <ol>
        <li>当社は、民法その他の法令に従い、本規約を変更することができます。</li>
        <li>当社は、本規約を変更する場合、変更内容、変更後の規約の効力発生日その他必要な事項を、本サービス又は当社Webサイトへの掲載、利用者への通知その他当社が適切と判断する方法により、事前に周知します。</li>
      </ol>
      <h2>第21条（準拠法・管轄）</h2>
      <ol>
        <li>本規約は日本法に準拠し、日本法に従って解釈されます。</li>
        <li>本サービス又は本規約に関する一切の紛争は、法令に別段の定めがある場合を除き、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
      </ol>
      <p>（以上、全21条）</p>
      <p>Ver.1.0　2026年8月1日</p>
    </main>
  );
};

export default TermsOfService;
